import { createFileRoute } from "@tanstack/react-router";
import { ogImageMeta } from "@/lib/seo/og-image";
import { pageSchemas } from "@/lib/seo/page-schema";
import { AutomotiveIndustryPageBG } from "@/components/site/AutomotiveIndustryPageBG";
import { AUTOMOTIVE_META_DESCRIPTION_BG } from "@/content/meta/AutomotiveIndustryPageBG";

export const Route = createFileRoute("/bg/industries/automotive")({
  head: () => ({
    meta: [
      { title: "Медиен мониторинг и анализи за автомобилния сектор | Perceptica" },
      {
        name: "description",
        content: AUTOMOTIVE_META_DESCRIPTION_BG,
      },

      { property: "og:title", content: "Медиен мониторинг и анализи за автомобилния сектор | Perceptica" },
      { property: "og:description", content: AUTOMOTIVE_META_DESCRIPTION_BG },
      { name: "twitter:card", content: "summary_large_image" },
      { name: "twitter:title", content: "Медиен мониторинг и анализи за автомобилния сектор | Perceptica" },
      { name: "twitter:description", content: AUTOMOTIVE_META_DESCRIPTION_BG },
      { property: "og:url", content: "https://perceptica.com/bg/industries/automotive" },
      ...ogImageMeta("bg", "/industries/automotive"),
      { property: "og:type", content: "website" },
    ],
  
    scripts: pageSchemas({ locale: "bg", path: "/industries/automotive" }),
  }),
  component: AutomotiveIndustryPageBG,
});
